import React from 'react';
import { motion } from 'framer-motion';
import { FileText, MessageSquare } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LANGUAGES } from '../../context/LanguageContext';
import { useLanguage } from '../../context/LanguageContext';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';

export function Contact({ onBriefClick, onContactClick }) {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleBriefClick = () => {
    const currentLang = location.pathname.split('/')[1];
    const lang = LANGUAGES.some(l => l.code === currentLang) ? currentLang : 'en';
    navigate(`/${lang}/checkout?plan=auction`);
  };

  return (
    <section id="contact" className="py-24 md:py-32">
      <div className="max-w-4xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight mb-4">
            {t('contact.title')}
          </h2>
          <p className="text-lg text-muted-foreground">
            {t('contact.subtitle')}
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6">
          {/* Brief Form */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.6 }}
          >
            <Card className="h-full flex flex-col" data-testid="contact-brief-card">
              <FileText className="text-primary mb-4" size={32} />
              <h3 className="font-heading text-xl font-semibold mb-2">
                {t('contact.brief.title')}
              </h3>
              <p className="text-muted-foreground mb-6 flex-grow">
                {t('contact.brief.description')}
              </p>
              <Button onClick={handleBriefClick} data-testid="fill-brief-btn">
                {t('contact.brief.cta')}
              </Button>
            </Card>
          </motion.div>

          {/* Quick Contact */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <Card className="h-full flex flex-col" data-testid="contact-quick-card">
              <MessageSquare className="text-primary mb-4" size={32} />
              <h3 className="font-heading text-xl font-semibold mb-2">
                {t('contact.simple.title')}
              </h3>
              <p className="text-muted-foreground mb-6 flex-grow">
                {t('contact.simple.description')}
              </p>
              <Button variant="outline" onClick={onContactClick} data-testid="quick-contact-btn">
                {t('contact.simple.cta')}
              </Button>
            </Card>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
